export enum BlackjackSideBet {
    TWENTY_ONE_PLUS_THREE = '21+3',
    PAIR = 'pair',
    INSURANCE = 'insurance',
    BB_MAIN = 'bbMain',
    BB_INSURANCE = 'bbInsurance',
    BB_SPLIT = 'bbSplit',
    BB_DOUBLE = 'bbDouble',
}
